import React from "react";
import { Box } from "@mui/material";

import { RoleGroupColumns } from "../../../data/DynamicTable/Collumns";
import { allRoleGroups } from "../../../data/Axios/queries";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { roleManagemenUrl } from "../../../config";
import RoleGroupForm from "./Forms";


const base_url = roleManagemenUrl.uri;

const RoleGroups = () => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const actions = {
    entity: "Role Group",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    activateDeactivate: {
      key: "ACTIVATEDEACTIVATE",
      button_name: "Deactivate",
      Show_Button: true,
      inputObjectName: "bulkActivateDeactivateRoleGroupesFn",
      permission: "ActivatePermission",
    },
    requiredId: "RoleGroupIds",
    UserId: userId,
  };

  return (
    <Box m="20px">
      <DynamicTable
        title="Role Group Management"
        subtitle="Manage Role Group "
        columns={RoleGroupColumns}
        FormComponent={RoleGroupForm}
        query={allRoleGroups}
        base_url={base_url}
        actions={actions}
      />
    </Box>
  );
};

export default RoleGroups;
